// removed by extract-text-webpack-plugin
module.exports = {"endUserAvatar":"endUserAvatar---2ZhvH","placeholderAvatar":"placeholderAvatar---2BOyW"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/EndUserAvatar/style.styl
// module id = 8/TF
// module chunks = 89